// extracted by mini-css-extract-plugin
export default {"main":"App404__main--lx92sQ","component404":"App404__component404--yoodYB"};